import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categoryName: string;
  publishedAt: string;
  readTime: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  category,
  categoryName,
  publishedAt,
  readTime,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            title={`${title} - 东升大舞台`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs rounded-md">
            {categoryName}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h4 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
            {title}
          </h4>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
            {excerpt}
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {publishedAt}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}